import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { LazyLoadEvent } from 'primeng/api';
import { Table } from 'primeng/table';
import { AuditoriaConferenciaCaixaGeral } from 'src/app/base/domain/auditoria-conferencia-caixa-geral.model';
import { Posto } from 'src/app/base/domain/posto.model';
import { CardListComponent } from '../../components/card-list/card-list.component';
import { QueryOptions } from '../../domain/query.options';

export interface AuditoriaConferenciaCaixaGeralListFilterOptions {
  postoSelecionado: Posto;
  dataInicial: Date;
  dataFinal: Date;
}

export interface AuditoriaConferenciaCaixaGeralAcaoEvent {
  acao: string;
  auditoriaConferenciaCaixaGeral: AuditoriaConferenciaCaixaGeral;
}

@Component({
  selector: 'app-auditoria-conferencia-caixa-geral-list',
  templateUrl: './auditoria-conferencia-caixa-geral-list.component.html',
  styleUrls: ['./auditoria-conferencia-caixa-geral-list.component.css'],
})
export class AuditoriaConferenciaCaixaGeralListComponent implements OnInit {
  @ViewChild('searchForm', { static: false }) searchForm: NgForm;
  @ViewChild('dataTable', { static: false }) dataTable: Table;
  @ViewChild(CardListComponent, { static: true }) cardList: CardListComponent;

  @Input() auditorias: AuditoriaConferenciaCaixaGeral[];
  @Input() title: string;
  @Input() type: string;
  @Input() totalRecords: number;
  @Input() rowsNumber: number;
  @Input() loading: boolean;
  @Input() filtros: string[];
  @Input() optionalColumns: string[];
  @Input() options: string[];

  @Output() filter = new EventEmitter<AuditoriaConferenciaCaixaGeralListFilterOptions>();
  @Output() loadListPage = new EventEmitter<number>();
  @Output() acaoClick = new EventEmitter<AuditoriaConferenciaCaixaGeralAcaoEvent>();

  private currentPage = 0;
  queryOptions = new QueryOptions();

  private readonly defaultFilterOptions: AuditoriaConferenciaCaixaGeralListFilterOptions = {
    postoSelecionado: null,
    dataInicial: null,
    dataFinal: null,
  };

  filterOptions: AuditoriaConferenciaCaixaGeralListFilterOptions;

  constructor() {
    this.onLimparFiltros();
  }

  ngOnInit(): void {}

  onAcaoClick(acao: string, domain: AuditoriaConferenciaCaixaGeral): void {
    this.acaoClick.emit({ acao, auditoriaConferenciaCaixaGeral: domain });
  }

  loadList(event: LazyLoadEvent): void {
    const pageNumber = Math.floor(event.first / event.rows);
    this.currentPage = pageNumber;
    this.loadListPage.emit(pageNumber);
  }

  onLimparFiltros(): void {
    this.filterOptions = Object.assign({}, this.defaultFilterOptions);
  }

  onAplicarFiltro(): void {
    this.filter.emit(this.filterOptions);
  }

  onAtualizar(): void {
    this.loadListPage.emit(this.currentPage);
  }

  generateMask(value: number): string {
    return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }
}
